import axios from '../../httpInstance/axios';
import { BATCH_URL } from '../../globals/urls';

/**
 * @param {object} payload
 * delete Batch
 * @payload
 * {
 *  eventType: 'batch' (optional),
 *  uuid: <UUID>,
 * }
 */

const deleteBatchService = async (payload) => {
  const { uuid } = payload;
  const response = await axios.delete(`${BATCH_URL}/${uuid}/`);
  return response.data;
};

export default deleteBatchService;
